var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#FFFFFF",
    height: "13px",
    width: "13px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490.8 490.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.1,297.189c1,0.3,2.1,0.4,3.1,0.4c4.3,0,8.4-2.3,10.7-6.2c47-82.8,96-88.4,151.9-88.8v49.6c0,4.6,2.6,8.8,6.7,10.9 c4.1,2.1,9,1.7,12.7-0.9l152.8-109.8c3.2-2.3,5.1-6,5.1-10s-1.9-7.7-5.1-10l-152.8-109.2c-3.7-2.7-8.6-3-12.7-0.9 c-4.1,2.1-6.6,6.3-6.6,10.9v50.4c-70.2,6-120.1,33.4-148.2,81.5c-23.9,40.8-26.7,88.2-26.7,120.3 C0,290.889,3.8,295.789,9.1,297.189z M187.7,107.289c6.5-0.3,11.6-5.7,11.6-12.2v-38l119.5,85.5l-119.5,85.8v-38 c0-3.2-1.3-6.4-3.6-8.7s-5.4-3.6-8.7-3.6l0,0c-53.8,0-109.1,0-159.9,63.1C35.9,177.989,69.7,113.189,187.7,107.289z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.9,154.889h62.4v290.4H119.9v-175.9c0-6.8-5.5-12.3-12.3-12.3s-12.2,5.6-12.2,12.3v188.2c0,6.8,5.5,12.3,12.3,12.3 h370.8c6.8,0,12.3-5.5,12.3-12.3v-315c0-6.8-5.5-12.3-12.3-12.3h-74.7c-6.8,0-12.3,5.5-12.3,12.3 C391.6,149.389,397.1,154.889,403.9,154.889z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/ImportIcon.dbc40a9745554c8a29fb5c35a018ee65.svg";
export { ForwardRef as ReactComponent };